import React from 'react';

export default () => {
    return (
        <>
            <p>Here is ManageMapFiles.Home</p>
        </>
    )
}